import PropTypes from 'prop-types'
import React from 'react'
import { Provider } from 'react-redux'
import CssBaseline from '@mui/material/CssBaseline'
import store from '../store'
import AppLoader from './AppLoader'
import AuthChecker from './AuthWrapper'
import SignedInBhanzuBot from './BhanzuBot'
import Alert from '../components/Alert'
import Navbar from './Navbar'
import ReadProgress from './ReadProgress'
import ThemeModeProvider from '../theme/ThemeModeProvider'

const Layout = ({ children }) => {
    return (
        <Provider store={store}>
            <ThemeModeProvider>
                <CssBaseline />
                {/* Writes cover the screen; reads show a bar under the header. */}
                <AppLoader />
                <ReadProgress />
                <Alert />
                {/* The gate wraps the page so a signed-out visitor never
                    mounts one (and never fires its API calls). */}
                <Navbar>
                    <AuthChecker>{children}</AuthChecker>
                </Navbar>
                {/* Once, above the routes: the panel and its conversation
                    survive every page change. */}
                <SignedInBhanzuBot />
            </ThemeModeProvider>
        </Provider>
    )
}

Layout.propTypes = {
    children: PropTypes.any,
}

export default Layout
